import React from 'react';

const BookActivityPlaceholder = ({ book, activityCode, imageUrl }) => {
  return (
    <div className="flex h-full min-h-0 w-full flex-1 flex-col bg-white">
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={`${book} - ${activityCode} activity page`}
          className="mx-auto h-full min-h-0 w-full max-h-[min(50dvh,56vh)] flex-1 object-contain p-2 md:max-h-full md:p-3"
        />
      ) : (
        <div className="flex h-full min-h-[38dvh] w-full flex-1 items-center justify-center bg-amber-50/60 p-6 text-center md:min-h-0">
          <div className="max-w-sm">
            <p className="text-amber-700 text-sm">
              Upload the task page for <strong>{activityCode}</strong> in <strong>{book}</strong>.
            </p>
            <p className="text-amber-600 text-xs mt-2">
              Storage path: <code>book-activities/{book.replace(/\s+/g, '_')}/{activityCode}/task-page.jpg</code>
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookActivityPlaceholder;
